<template>
	<div v-bind:class="{active: active}" tabindex="0" @focusout="onFocusOut" >
		<button @click="onButtonClick" class="dropdown-button">
			<slot name="button"></slot>
			<div class="dropdown-arrow" :class="{upwardsArrow: active}"></div>
		</button>
		<div class="dropdown-list">
			<slot name="dropdown"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				active: false,
				showingPopup: false
			}
		},
		mounted() {
			this.$root.$on("showPopup", (boolean) => {
				if (boolean) {
					this.showingPopup = true;
				}
				else {
					this.showingPopup = false;
				}
			})
		},
		methods: {
			onButtonClick() {
				this.active = !this.active;
			},
			onFocusOut() {
				if (this.showingPopup) {
					this.active = true;
					this.showingPopup = false;
					setTimeout(() => {
						this.active = false;
					}, 3000);
				}
				else {
					setTimeout(() => {
						this.active = false;
					}, 300);
				}
				this.showingPopup = false;
			}
		}
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dropdown.vue